import { useEffect, useRef,useContext, useState } from 'react';

import classes from './Notifications.module.scss';
import LoginContext from '../../../../../store/login-context';
import push from '../../../../../assets/img/push_notification.png';
import Ajax from '../../../../../Handler/Ajax';
import PushBottom from '../Bottom/PushBottom';
import Toast from '../../../../Form/Toast';
import GovSpinner from '../../../../Form/GovSpinner';

declare function Translate(key: string): string;

var MAX_DURATION = 40000; // 40 seconds
const RETRY_DELAY = 1500;   // 1.5 seconds

const PushNotifications = (props) => {
    const ctx = useContext(LoginContext);
    const startTimeRef = useRef<number>(0);

    useEffect(() => {
        startTimeRef.current = Date.now();
        if(props.isNewUser) MAX_DURATION = 120000;
        checkUnibeamStatus();
    },[]);

    const [serverMessage,setServerMessage] = useState('');
    const [loading,setLoading] = useState(false);
    
    const checkUnibeamStatus = () => {
        if(!ctx.devMode){
            Ajax.CheckUnibeamStatus()
                .then(() => {
                    setLoading(true);
                    Ajax.onPKILoginEnd()
                    .then((data: any) => {
                        if(data.neededInfo[0].trim().length === 0 && data.currentState === "updateDetailsDone"){                                    
                            Ajax.onPKILoginEndPK()
                                .then((data: any) => {
                                    setLoading(false);
                                    props.Success(data.neededInfo);
                                })
                                .catch((error) => {                            
                                    setLoading(false);
                                    setServerMessage(Translate(error) !== '' ? Translate(error) : Translate('N_General_Error_SYSTEM_ERROR'));                    
                                });                                                                        
                        }
                        else{
                            setLoading(false);
                            props.Success(data.neededInfo);
                        }               
                    })
                    .catch((error) => {                        
                        setLoading(false);
                        setServerMessage(Translate(error) !== '' ? Translate(error) : Translate('N_General_Error_SYSTEM_ERROR'));                    
                    });                 
                })
                .catch((data: any) => {
                    const elapsed = Date.now() - startTimeRef.current;

                    if(data && data.isError){
                        if(data.errorCode === "AUTH_REJECTED"){
                            props.onReject();
                            return;
                        }
                        else if(data.errorCode === "PUSH_NOTIFICATIONS_simID_OR_deviceID_DO_NOT_MATCH") {
                            props.onSimOrDeviceChanged(data.maskedEmail);
                            return; 
                        }
                        else if (data.errorCode === "ERROR_UB_AUTH_FAILED_FALLBACK_SMS"){
                            props.redirectToSms(data.otpDestMasked, data.maskedEmail);
                            return;
                        }
                    }

                    if (elapsed >= MAX_DURATION) { 
                        props.isNewUser ?  props.onExpired(1) : props.onExpired(2);                                                                          
                        return;
                    }
    
                    setTimeout(checkUnibeamStatus, RETRY_DELAY);
                });
        }
        else{
            Ajax.CheckUnibeamStatusDemo()
                .then(() => {
                    ctx.setSuccess();
                })
                .catch((data:any) => {
                    const elapsed = Date.now() - startTimeRef.current;

                    if(data && data.isError){
                        if(data.errorCode === "AUTH_REJECTED"){
                            props.onReject();
                            return;
                        }
                        else if(data.errorCode === "PUSH_NOTIFICATIONS_simID_OR_deviceID_DO_NOT_MATCH") {
                            props.onSimOrDeviceChanged(data.maskedEmail);
                            return; 
                        }
                        else if (data.errorCode === "ERROR_UB_AUTH_FAILED_FALLBACK_SMS"){
                            props.redirectToSms(data.otpDestMasked, data.maskedEmail);
                            return;
                        }
                    }

                    if (elapsed >= MAX_DURATION) {
                        props.isNewUser ?  props.onExpired(1) : props.onExpired(2); 
                        return;
                    }
    
                    setTimeout(checkUnibeamStatus, RETRY_DELAY);
                });
        }
    }

    const onResetErrorHandler = (error:string) => {
        setServerMessage(Translate(error) !== '' ? Translate(error) : Translate('N_General_Error_SYSTEM_ERROR'));
    };

    return (
        <>
            <GovSpinner show={loading} />

            <div className={classes.main}>
                {serverMessage.length > 0 && (
                    <Toast message={serverMessage} />
                )}

                <img src={push} className={classes.img} alt="" />
                <div className={classes.title}>
                {Translate('N_General_unibeam_2')}    
                </div>
                <div className={classes.title}>
                    { props.isNewUser ? Translate('N_General_unibeam_3') : Translate('N_General_unibeam_9') }  
                </div>
                {props.isNewUser && 
                    <div className={classes.descContainer}>
                        <div className={classes.desc}>
                            {Translate('N_General_unibeam_4')}    
                        </div>
                        <div className={classes.desc}>
                            {Translate('N_General_unibeam_4_2')}    
                        </div>
                        <div className={classes.confirm}>
                            {Translate('N_General_unibeam_5')}      
                        </div>
                        <hr />
                    </div>
                }
                {!props.isNewUser &&
                    <div className={classes.descContainer}>
                        <div className={classes.desc}>
                            {Translate('N_General_unibeam_10')}
                        </div>
                        <div className={classes.confirm}>
                            <span className={classes.bold}>{Translate('N_General_unibeam_11')}</span>&nbsp;
                            <span>{Translate('N_General_unibeam_12')}</span>&nbsp;                            
                        </div>
                        <div>
                            <span>{Translate('N_General_unibeam_14')}</span>
                        </div>                
                        <hr />
                    </div>
                }
            
                <PushBottom onResetError={onResetErrorHandler}/>
            </div>
        </>
    );

};
export default PushNotifications;